import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import s from './index.module.css';
import ExpertDialog from '../ExpertDialog';

import dialogActions from '../../store/actions/dialogs';
import messagesActions from '../../store/actions/messages';
import expertsActions from '../../store/actions/experts';
import metaActions from '../../store/actions/meta';
import {
    getCurrentDialogId,
    getUnreadDialogsCount,
    getMessagesItems,
    getSavedMessages,
    getExpertsOnlineStatus,
} from '../../store/selectors';
import ArchiveDialogs from './ArchiveDialogs';

const CONSULTATION_HEADER_TEXT = {
    CURRENT_BLOCK: 'Активные консультации',
    PREVIOUS_BLOCK: 'История консультаций'
};

let oldDialogId = null;

const ConsultationsBlock = ({ isCurrentConsultations, dialogsList, isArchiveDialog = false }) => {
    const dispatch = useDispatch();
    const recentUnreadDialogsCount = useSelector(getUnreadDialogsCount);
    const savedMessages = useSelector(getSavedMessages);
    const currentDialogId = useSelector(getCurrentDialogId);
    const messages = useSelector(getMessagesItems);
    const expertsOnlineStatus = useSelector(getExpertsOnlineStatus);
    const [dialogsIdList, setDialogsIdList] = useState([]);

    const headerText = isCurrentConsultations
        ? CONSULTATION_HEADER_TEXT.CURRENT_BLOCK
        : CONSULTATION_HEADER_TEXT.PREVIOUS_BLOCK;

    const setActiveDialog = (dialogId, expertId, statusId) => {
        expertId = statusId !== 1 ? null : expertId;

        dispatch(metaActions.setCurrentMobileLayout('chat'));
        dispatch(dialogActions.setIsArchiveCurrentDialog(isArchiveDialog));
        dispatch(dialogActions.setCurrentDialogId(dialogId));
        dispatch(expertsActions.setActiveExpertId(expertId));

        dispatch(expertsActions.setCallNewExpertButtonDisabled(false));
    };

    const setSavedMessages = (dialogId, isNotContained) => {
        if (isNotContained) {
            if (messages.length) {
                dispatch(messagesActions.saveFetchedMessages(messages, dialogId));
            }
        }
    };

    useEffect(() => {
        if (currentDialogId && currentDialogId !== oldDialogId) {
            const dialogMessagesSaved = savedMessages.filter(sm => sm.dialogId === currentDialogId);
            if (!dialogsIdList.includes(currentDialogId)) {
                setDialogsIdList([...dialogsIdList, currentDialogId]);
            }

            dispatch(messagesActions.fetchMessages(currentDialogId));
            oldDialogId = currentDialogId;
            setSavedMessages(currentDialogId, !dialogMessagesSaved[0]);
        }
    }, [currentDialogId]);

    const getExpertDialog = () => {
        return dialogsList.map((dialog, index) => {
            const {
                expert_rating: ratingInfo,
                last_update_timestamp: lastMessageTime,
                buyer_car_brand: carBrand,
                dialog_id,
                expert_id,
                status_id
            } = dialog;

            const photoPath = dialog.expert?.picture_path;
            const name = dialog.expert?.name;
            const rating = ratingInfo?.rating;
            const isOnline = expertsOnlineStatus &&
                expertsOnlineStatus.filter(t => t.expertId === dialog.expert_id)[0]?.isOnline;

            const unreadDialog = recentUnreadDialogsCount?.find(d => d.dialog_id === dialog_id);

            return (
                <ExpertDialog
                    key={`${name}-${index}`}
                    isActive={currentDialogId === dialog_id}
                    carBrand={carBrand}
                    dialogId={dialog_id}
                    name={name}
                    rating={rating}
                    photoPath={photoPath}
                    dialogTime={lastMessageTime}
                    isOnline={isOnline}
                    unreadMessages={unreadDialog?.unread_count}
                    setActiveDialog={() => setActiveDialog(dialog_id, expert_id, status_id)} />
            );
        });
    }

    const expertDialog = dialogsList && getExpertDialog(dialogsList);

    return (
        <>
            {isArchiveDialog
                ? <ArchiveDialogs
                    isActive={currentDialogId === dialogsList[0].dialog_id}
                    setActiveDialog={() => setActiveDialog(dialogsList[0].dialog_id)} />
                : <>
                    <h4 className={s.consultationHeader}>{headerText}</h4>
                    {dialogsList.length > 0 && <ul className={s.expertDialogList}>{expertDialog}</ul>}
                </>
            }
        </>
    );
};

export default ConsultationsBlock;
